/* ih-v4-home.js — homepage v4 (Oct 20 2026).
   Phone quick-actions bar: shown once the hero's buttons have scrolled up out of
   view, hidden again while any [data-ihx4-mbar-hide] section or the footer is on
   screen (they carry the same actions). No hero on the page → shown after 600px.
   Loaded by several sections with `defer`; the guard makes repeat loads no-ops. */
(function () {
  if (window.__ihx4Home) return;
  window.__ihx4Home = true;

  function init() {
    var bar = document.querySelector('[data-ihx4-mbar]');
    if (!bar) return;
    var heroCtas = document.querySelector('[data-ihx4-hero-ctas]');
    var hideZones = Array.prototype.slice.call(document.querySelectorAll('[data-ihx4-mbar-hide]'));
    var footer = document.querySelector('.ihx4f') || document.querySelector('footer');
    if (footer) hideZones.push(footer);

    var pastHero = false;
    var inHide = new Set();

    function render() {
      var on = pastHero && inHide.size === 0;
      bar.classList.toggle('is-on', on);
    }

    if ('IntersectionObserver' in window) {
      if (heroCtas) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            /* past = the buttons are out of view ABOVE the viewport */
            pastHero = !e.isIntersecting && e.boundingClientRect.top < 0;
          });
          render();
        }).observe(heroCtas);
      } else {
        var onScroll = function () { pastHero = window.scrollY > 600; render(); };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
      var hideIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) inHide.add(e.target); else inHide.delete(e.target);
        });
        render();
      }, { rootMargin: '0px 0px -20% 0px' });
      hideZones.forEach(function (z) { hideIO.observe(z); });
    } else {
      pastHero = true;
      render();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
